import $ from "jquery";
import "./summaryPagePortal.scss";
import "jquery-validation";
import { createPDF } from "../../../../core/customFunctions/createPDF";
import {
  changeSceneTime,
  GetGroup,
  pergola,
  stoneFloor,
  toggleBackWall,
  toggleLeftWall,
  toggleLoad,
  toggleRightWall,
} from "../../../../core/3d-configurator";
import { state } from "../../../../core/settings";

function saveFormData() {
  const formData = {
    firstname: $("#firstname").val(),
    phoneNumber: $("#phoneNumber").val(),
    email: $("#email").val(),
    zipCode: $("#zip-code").val(),
    comment: $("#comment").val() || "",
    agree: $("#agree").is(":checked"),
  };
  localStorage.setItem("summaryFormData", JSON.stringify(formData));
}

export function loadFormData(container) {
  const savedData = JSON.parse(localStorage.getItem("summaryFormData"));

  if (savedData) {
    $(`${container} #firstname`).val(savedData.firstname);
    $(`${container} #phoneNumber`).val(savedData.phoneNumber);
    $(`${container} #email`).val(savedData.email);
    $(`${container} #zip-code`).val(savedData.zipCode);
    $(`${container} #comment`).val(savedData.comment);
    $(`${container} #agree`).prop("checked", savedData.agree);
  }
}

export function summaryPagePortalComponent(container, downloadPDF = true) {
  const html = $(`
    <div class='summary-portal' id="sum-portal-with-comment">
      <div class="form-container">
        <form class="form" id="form">
          <div class="form__header">
           <h2 class="form__header__title">
             "Fill in details below to Request a quote:"
           </h2>

        <button type="button" id="closeForm" class="form__header__close"></button>
          </div>
     
              <div class="form__top">
                <div class="form__group">
                  <input class="form__input" type="text" id="firstname" name="firstname" class="form-control" placeholder="First & Last name*">
                </div>
              
                <div class="form__group">
                  <input class="form__input" type="text" id="phoneNumber" name="phoneNumber" class="form-control" placeholder="Telephone">
                </div>
              </div>

              <div class="form__group">
                <input class="form__input" type="email" id="email" name="email" class="form-control" placeholder="Email*">
              </div>

              <div class="form__top">
                <div class="form__group">
                  <input class="form__input" type="text" id="zip-code" name="zip-code" class="form-control" placeholder="Zip-code*">
                </div>
              </div>

              <div class="form__group">
                <select class="form__input" id="project-timeline" name="project-timeline">
                  <option value="" disabled selected>How soon are you trying to finish your project?</option>
                  <option>Immediately</option>
                  <option>In 1-2 weeks</option>
                  <option>In 1 month</option>
                  <option>In 3 months</option>
                  <option>In 6 months</option>
                  <option>Just browsing / not sure</option>
                </select>
              </div>

              <div class="form__group">
                <select class="form__input" id="usage-type" name="usage-type">
                  <option value="" disabled selected>Select usage type</option>
                  <option>Residential</option>
                  <option>Commercial</option>
                </select>
              </div>

              <div class="form__group">
                <select class="form__input" id="source" name="source">
                  <option value="" disabled selected>Select Where did you find us?</option>
                  <option>Google Search</option>
                  <option>Bing</option>
                  <option>Facebook</option>
                  <option>Wayfair</option>
                  <option>Exhibition</option>
                  <option>News Paper</option>
                  <option>Other</option>
                </select>
              </div>
              

          <div class="form__check">
            <input type="checkbox" id="agree" name="agree" class="form__check-input">
            <label for="agree" class="form__check__label">
                I agree to the collection, storage, and processing of my personal data by this website.
            </label>
          </div>

          <div class="form__buttons">
            <button type="button" id="cancelButton" class="form__buttons__button form__buttons__button--back">Cancel</button>
            <button type="submit" class="form__buttons__button">
              Request Quote
            </button>
          </div>
        </form>
      </div>
    </div>
  `);

  html.hide();
  const form = html.find("#form");

  $(container).append(html);

  $.validator.addMethod(
    "phoneNumber",
    function (value, element) {
      const regex = /^[0-9]{10}$/;
      return this.optional(element) || regex.test(value);
    },
    "Please enter a valid phone number (10 digits)."
  );

  $.validator.addMethod(
    "adress",
    function (value, element) {
      return this.optional(element) || value.length > 4;
    },
    "Please enter a valid address."
  );

  $.validator.addMethod(
    "zipCode",
    function (value, element) {
      return this.optional(element) || /^[0-9]{4,10}$/.test(value);
    },
    "Please enter a valid zip code."
  );

  form.validate({
    rules: {
      firstname: {
        required: true,
        minlength: 2,
      },
      phoneNumber: {
        required: true,
        phoneNumber: true,
      },
      email: {
        required: true,
        email: true,
      },
      adress: {
        required: true,
        adress: true,
      },
      "zip-code": {
        required: true,
        zipCode: true,
      },
      city: {
        required: true,
        minlength: 2,
      },
      agree: {
        required: true,
      },
      comment: {
        required: false,
      },

      "project-timeline": {
        required: true,
      },
      "usage-type": {
        required: true,
      },
      source: {
        required: true,
      },
    },
    messages: {
      firstname: {
        required: "Please enter your first name",
        minlength: "Your name must be at least 2 characters long",
      },
      phoneNumber: {
        required: "Please enter your phone number",
        phoneNumber: "Phone number must be 10 digits",
      },
      email: {
        required: "Please enter your email",
        email: "Please enter a valid email address",
      },
      adress: {
        required: "Please enter your address",
        adress: "Address must be more than 4 characters",
      },
      "zip-code": {
        required: "Please enter your zip code",
        zipCode: "Zip code must be 4 to 10 digits",
      },
      city: {
        required: "Please enter your city",
        minlength: "City name must be at least 2 characters long",
      },
      agree: {
        required: "You must agree to the terms and conditions",
      },
      "project-timeline": {
        required: "Please select when you plan to finish the project",
      },
      "usage-type": {
        required: "Please select usage type",
      },
      source: {
        required: "Please tell us how you found us",
      },
    },
    submitHandler: async function (form, event) {
      event.preventDefault();

      console.log("FORM SUBMITTED!");

      try {
        // Prepare scene
        let oldDayMode = state.dayMode;
        toggleLoad(true);

        if (!state.dayMode) {
          changeSceneTime("Day");
        }

        stoneFloor.visible = false;

        await new Promise(resolve => setTimeout(resolve, 500));

        console.log("Generating PDF as base64...");
        const pdfBase64 = await createPDF("base64");
        console.log("PDF base64 generated, length:", pdfBase64.length);

        console.log("Downloading PDF for user...");
        await createPDF("download");

        console.log("Sending data to Google Sheets...");
        await sendFormDataToGoogleSheets(pdfBase64);
        console.log("Data sent! Email with PDF should arrive shortly.");

        if (!oldDayMode) {
          changeSceneTime("Night");
        }

        toggleLoad(false);
        html.hide();
        stoneFloor.visible = true;

      } catch (error) {
        console.error("ERROR:", error);
        alert("Error submitting form: " + error.message);
        toggleLoad(false);
      }
    },
  });

  const cancelButton = html.find("#cancelButton");
  const closeButton = html.find("#closeForm");

  closeButton.on("click", function () {
    if (false) {
      toggleLoad(true);
      $("html, body").animate({ scrollTop: 0 }, "fast", () => {
        $("#summary-content").hide();
        $("body").removeClass("body-overflow-auto");
      });
      toggleLoad(false);
      html.hide();
    } else {
      html.hide();
      $("body").addClass("body-overflow-auto");
    }
  });

  cancelButton.on("click", function () {
    if (false) {
      toggleLoad(true);
      $("html, body").animate({ scrollTop: 0 }, "fast", () => {
        $("#summary-content").hide();
        $("body").removeClass("body-overflow-auto");
      });
      toggleLoad(false);
      html.hide();
    } else {
      $("#form")[0].reset();
      form.validate().resetForm();
      html.hide();
      $("body").addClass("body-overflow-auto");
    }
  });
}

async function sendFormDataToGoogleSheets(pdfBase64 = null) {
  // SCRIPT_ID
  const scriptDeploymentId =
    "AKfycbyZhixSGDKY3i2XqCHnGpgvLbnACFdNciGUbGJiZinfInNSGNh_4__5FrgsFGkQttJW";
    // "AKfycbwpuC-vkmr59IZ9-9xRO4h2tlXikMMWb14R1Ozfp1Y-KOuF0WeP-NOxNFrfmmr4ZWeUoA";

  const formData = {
    firstname: $("#firstname").val(),
    phoneNumber: $("#phoneNumber").val(),
    zipCode: $("#zip-code").val(),
    email: $("#email").val(),
    projectTimeline: $("#project-timeline").val(),
    usageType: $("#usage-type").val(),
    uri: window.location.href,
    source: $("#source").val(),
    width: state.width.toFixed(1),
    length: state.length.toFixed(1),
    height: state.height.toFixed(1),
    frameColor: state.selectedFrameColorName,
    roofColor: state.selectedRoofColorName,
  };

  if (pdfBase64) {
    formData.pdfData = pdfBase64;
    console.log("Sending form data WITH PDF...");
  } else {
    console.log("Sending form data WITHOUT PDF...");
  }


  return new Promise((resolve, reject) => {
    $.ajax({
      url: `https://script.google.com/macros/s/${scriptDeploymentId}/exec`,
      method: "POST",
      data: formData,
      success: function (response) {
        console.log("SUCCESS:", response);
        resolve(response);
      },
      error: function (xhr, status, err) {
        console.error("AJAX ERROR:", {
          status: status,
          error: err,
          responseText: xhr.responseText
        });
        reject(err);
      },
    });
  });
}
